var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 36,
    viewBox: "0 0 375 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M0 36L375 36V0.52002L0 0.52002V36Z",
    fill: "url(#paint0_linear_458_21)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_21",
    x1: 187.5,
    y1: 45.12,
    x2: 187.5,
    y2: 5.63002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#A2A3C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C4C6C8",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomShadow);
export default __webpack_public_path__ + "static/media/bottom-shadow.ebf29cff8e42d59f991ec1db3f719a33.svg";
export { ForwardRef as ReactComponent };